angular.module('impactx.user').controller('IxReferenceUserController', ['$scope', '$mdDialog', IxReferenceUserController]);
function IxReferenceUserController($scope, $mdDialog) {

    var self = this;

    self.openInfoDialog = function(ev, userData) {
        //Hide all others.
        $mdDialog.hide();

        $mdDialog.show({
            controller: 'SimpleDialogCtrl',
            controllerAs: 'simpleDialogCtrl',
            templateUrl: 'shared/user/templates/usercontact.dialog.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            fullscreen: false,
            locals: {
                userData: userData,
                buttonFunction: undefined,
                buttonTranslation: undefined
            }
        });
    };
}